module.exports = __webpack_public_path__ + "static/media/elipse.36580c08.svg";